import gql from 'graphql-tag';

export const CREATE_MERCHANT = gql`
  mutation createMerchant(
    $params: CreateMerchantInput!
    $brandId: ID!
    $categories: [String]!
    $action: ModifyAction!
  ) {
    createMerchant(params: $params) {
      success
    }

    modifyBrandCategoryDefaults(
      brandId: $brandId
      categories: $categories
      action: $action
    ) {
      categories
    }
  }
`;

export const CREATE_MERCHANT_BRAND_ASSETS = gql`
  mutation upsertBrandAsset(
    $brandId: ID!
    $bundle: BrandAssetBundleName!
    $assets: [JSON!]!
    $brandMatchers: [BrandTransactionMatcherInput!]!
    $placesMatchers: [BrandPlaceMatcherInput!]!
  ) {
    upsertBrandAsset(brandId: $brandId, bundle: $bundle, assets: $assets) {
      success
    }

    setBrandTransactionMatchers(brandId: $brandId, matchers: $brandMatchers) {
      success
    }

    setBrandPlaceMatchers(brandId: $brandId, matchers: $placesMatchers) {
      success
    }
  }
`;

export default CREATE_MERCHANT;
